import React, { useEffect, useState, useRef } from 'react'
import CRMLayout from '../../../../../../layout/components/CRMLayout';
import documentTemplateServices from '../documentTemplateServices';
import { useParams } from 'react-router-dom';
import DocumentTemplateForm from '../components/DocumentTemplateForm';
import AppCKEditor from '../../../../../../components/AppInput/AppCKEditor';
import { useAlert } from '../../../../../../context/AlertContext';
import { Save } from '@mui/icons-material';

// --- NEW COMPONENT: Isolated Preview Window ---
function SafeIframePreview({ htmlContent }) {
    const iframeRef = useRef(null);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        // Get the iframe's document context
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        
        // Inject a raw, clean HTML page structure that is 100% immune to your page's Bootstrap
        const completeHtml = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="utf-8">
                <style>
                    body {
                        margin: 0;
                        padding: 0.5in;
                        font-family: Arial, sans-serif;
                        background-color: #ffffff;
                    }
                    /* Simple resets to replicate CKEditor view styling exactly */
                    figure.table {
                        width: 100% !important;
                        margin: 0 0 1em 0;
                    }
                    table {
                        width: 100% !important;
                        border-collapse: collapse;
                    }
                    td {
                        border: 0 none transparent !important;
                    }
                    .image_resized {
                        display: inline-block;
                    }
                    .image_resized img, img {
                        max-width: 100% !important;
                        height: auto !important;
                        display: block;
                        margin-left: auto;
                        margin-right: auto;
                    }
                </style>
            </head>
            <body>
                <div class="ck-clean-layout">
                    ${htmlContent}
                </div>
            </body>
            </html>
        `;

        // Write content cleanly into the iframe
        doc.open();
        doc.write(completeHtml);
        doc.close();
    }, [htmlContent]);

    return (
        <iframe
            ref={iframeRef}
            title="Document Template Preview"
            style={{
                width: '100%',
                minHeight: '11.69in', // Matches A4 height scale
                border: '1px solid #dee2e6',
                backgroundColor: '#ffffff',
                boxSizing: 'border-box'
            }}
        />
    );
}

// --- MAIN PAGE COMPONENT ---
function DocumentTemplateDetailsPage() {
    const {id} = useParams();
    const {AppAlert} = useAlert();
    const [documentDetails,setDocumentDetails] = useState(null)
    const [title,setTitle] = useState("");
    const [details,setDetails] = useState("");

    const [editmode,setEditMode] = useState(false);

    const getDocumentDetails = () =>{
        documentTemplateServices.getById(id).then(res=>{
            setDocumentDetails(res.data);
            setTitle(res.data.title);
            setDetails(res.data.details);
        }).catch(error=>{

        }).finally(()=>{

        })
    }

    useEffect(()=>{
        getDocumentDetails();
    },[id])


    const update = () =>{
        let payload = {
            id:id,
            details:details,
        }
        documentTemplateServices.save(payload).then(res=>{
            AppAlert("Document Updated Successfully");
            setEditMode(false);
            
        }).catch(error=>{
            AppAlert("SomeThing Went wrong","error");
        })
    }

    return (
        <CRMLayout>
            {documentDetails &&
                <div className='row'>
                    <div className='col-md-10'>
                        {editmode ? 
                            <AppCKEditor value={details} setValue={setDetails} />
                            :
                            /* FIXED: Swapped dangerouslySetInnerHTML for our clean SafeIframePreview component */
                            <SafeIframePreview htmlContent={details} />
                        }
                    </div>
                    <div className='col-md-2'>
                        {editmode ?
                            <button className='btn btn-success' onClick={update}><Save/> Save</button>
                            :
                            <button className='btn btn-outline-primary' onClick={()=>setEditMode(true)} > Edit</button>
                        }
                    </div>
                </div>
            }
        </CRMLayout>
    )
}

export default DocumentTemplateDetailsPage;